// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment-timezone';

// -- views
import LocalizableSelect from './LocalizableSelect';

export default class TimeZoneChooser extends Component {

  static defaultProps = {
    clearable: false,

    readOnly: false
  };

  static propTypes = {
    // 'Europe/Paris' for example
    value: PropTypes.string.isRequired,

    // param: String (Country code 'FR' for example.)
    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool,

    readOnly: PropTypes.bool
  };

  onChange = (option) => {
    if (_.isNull(option)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(option.value);
    }
  };

  render() {
    const options = [];
    const zonesNames = moment.tz.names();

    _.each(zonesNames, (zoneName: string) => {
      const utcOffset = moment.tz(zoneName).utcOffset() / 60; // to hour
      const isPositive = utcOffset > 0;
      const utcOffsetString = isPositive ? `+${utcOffset}` : `${utcOffset}`;

      options.push({
        label: `${zoneName} (${utcOffsetString})`,
        value: zoneName
      });
    });

    return (
      <div className="country_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.value}
          options={options}
          onChange={this.onChange}
          clearable={this.props.clearable}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }

}
